function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changePassword, closeConfirmation, closeModal, confirmDeletion, deleteAccount, deleteAuthToken, openConfirmation } from "@common/actions";
import Spinner from "@common/components/Spinner";
import { deleteOrderObject, deleteSessionLockTime, deleteTokenObject } from "@common/services/helpers";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS } from "@config/constants";
var DeleteAccount = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(DeleteAccount, PureComponent);
    var _super = _create_super(DeleteAccount);
    function DeleteAccount(props) {
        _class_call_check(this, DeleteAccount);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            password: "",
            passwordError: "",
            serverError: "",
            deletionRequestPending: false
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.validatePassword = _this.validatePassword.bind(_assert_this_initialized(_this));
        _this.handleDeleteAccount = _this.handleDeleteAccount.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(DeleteAccount, [
        {
            key: "handleDeleteAccount",
            value: /**
     * If there are no password errors opens confirmation modal.
     */ function handleDeleteAccount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, i18n, _$confirmDeletion, _$closeConfirmation, passwordError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.validatePassword()
                                ];
                            case 1:
                                _state.sent();
                                _this_props = _this.props, i18n = _this_props.i18n, _$confirmDeletion = _this_props.confirmDeletion, _$closeConfirmation = _this_props.closeConfirmation;
                                passwordError = _this.state.passwordError;
                                if (!passwordError) {
                                    _this.props.openConfirmation({
                                        message: i18n.account.areYouSureDelete,
                                        confirmMethod: function() {
                                            return _$confirmDeletion(true);
                                        },
                                        declineMethod: _$closeConfirmation
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Sets the new state for a given input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var isCheckbox = type === "checkbox";
                var key = isCheckbox ? value : name;
                var newValue = isCheckbox ? checked : value;
                this.setState(_define_property({}, key, newValue), this.validatePassword);
            }
        },
        {
            /**
     *  Validates a password and sets the appropriate
     *  error in the state.
     */ key: "validatePassword",
            value: function validatePassword() {
                var password = this.state.password;
                var passwordError = this.props.i18n.authentication.enterPassword;
                password.length === 0 ? this.setState({
                    passwordError: passwordError
                }) : this.setState({
                    passwordError: ""
                });
            }
        },
        {
            /**
     * Renders the inputs.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var _this_state = this.state, password = _this_state.password, passwordError = _this_state.passwordError, serverError = _this_state.serverError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(TextField, {
                        className: "ux-text-field-root",
                        InputProps: {
                            onBlur: this.validatePassword,
                            onFocus: function() {
                                return _this.setState({
                                    serverError: ""
                                });
                            },
                            className: "ux-input password",
                            classes: {
                                error: "ux-input-error"
                            }
                        },
                        InputLabelProps: {
                            classes: {
                                root: "ux-input-label"
                            }
                        },
                        FormHelperTextProps: {
                            error: true,
                            classes: {
                                root: "ux-form-helper-text"
                            }
                        },
                        error: passwordError !== "" || serverError !== "",
                        helperText: passwordError || serverError,
                        id: "password-profile",
                        type: "password",
                        autoComplete: "off",
                        name: "password",
                        value: password,
                        required: true,
                        label: i18n.authentication.password,
                        onChange: this.onChange,
                        margin: "none"
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, i18n = _this_props.i18n, componentMap = _this_props.componentMap, componentName = _this_props.componentName, toggleComponent = _this_props.toggleComponent;
                var parentProps = componentMap[componentName].parentProps;
                return /*#__PURE__*/ _jsx("div", {
                    className: "main-wrapper delete-account-wrapper",
                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "delete-account-content",
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "margin-bottom-small",
                                        children: i18n.account.important
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "margin-bottom-tiny",
                                        children: [
                                            i18n.account.afterConfirmDesc,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-done"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "with-padding margin-bottom-tiny",
                                        children: i18n.account.deleteAccDesc1
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-done"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "margin-bottom-tiny",
                                        children: i18n.account.deleteAccDesc2
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-done"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "margin-bottom-tiny",
                                        children: i18n.account.deleteAccDesc3
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-done"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "with-padding margin-bottom-small",
                                        children: i18n.account.deleteAccDesc4
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "margin-bottom-tiny",
                                        children: i18n.account.accessDenied
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "margin-top-small",
                                        children: i18n.account.areYouSure
                                    }),
                                    /*#__PURE__*/ _jsx("form", {
                                        children: this.renderInputs()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "modal-footer",
                                children: [
                                    /*#__PURE__*/ _jsxs(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: function() {
                                            return toggleComponent(componentMap[componentName].parentComponentName, parentProps);
                                        },
                                        className: "button-no-background raised half-width float-left center-vertical go-back-button",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-keyboard-arrow-right"
                                            }),
                                            i18n.player.back
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: this.handleDeleteAccount,
                                        className: "button go-forward-button raised half-width white-text float-right center-vertical",
                                        children: this.state.deletionRequestPending ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: i18n.account.confirm
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-keyboard-arrow-right"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps, nextState) {
                var _this = this;
                return _async_to_generator(function() {
                    var password, errors, _this_props, i18n, enqueueSnackbar, token, data, response, error, hasSpecificServerError, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(nextProps.userDetails.isDeletionConfirmed && !nextState.deletionRequestPending && nextProps.userDetails.isDeletionConfirmed !== _this.props.userDetails.isDeletionConfirmed)) return [
                                    3,
                                    4
                                ];
                                password = _this.state.password;
                                errors = _this.props.i18n.errors;
                                _this_props = _this.props, i18n = _this_props.i18n, enqueueSnackbar = _this_props.enqueueSnackbar;
                                token = _this.props.authentication.token;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                data = {
                                    password: password,
                                    token: token
                                };
                                _this.setState({
                                    deletionRequestPending: true
                                });
                                return [
                                    4,
                                    _this.props.deleteAccount(data)
                                ];
                            case 2:
                                response = _state.sent();
                                _this.setState({
                                    deletionRequestPending: false
                                });
                                if (response.status === STATUS_CODE_SUCCESS) {
                                    _this.props.closeConfirmation();
                                    _this.props.closeModal();
                                    deleteTokenObject();
                                    deleteSessionLockTime();
                                    deleteOrderObject();
                                    _this.props.deleteAuthToken();
                                    enqueueSnackbar(i18n.snackbar.deleteAccountSuccess, {
                                        variant: SNACKBAR_VARIANT_SUCCESS,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.props.closeConfirmation();
                                _this.props.confirmDeletion(false);
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    errorText = errors["error".concat(error.subcode)];
                                    _this.setState({
                                        serverError: errorText
                                    });
                                    _this.setState({
                                        deletionRequestPending: false
                                    });
                                    enqueueSnackbar(i18n.snackbar.deleteAccountFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DeleteAccount;
}(PureComponent);
var mapStateToProps = function(param) {
    var authentication = param.authentication, userDetails = param.userDetails;
    return {
        authentication: authentication,
        userDetails: userDetails
    };
};
export default withSnackbar(withRouter(connect(mapStateToProps, {
    changePassword: changePassword,
    closeModal: closeModal,
    deleteAccount: deleteAccount,
    deleteAuthToken: deleteAuthToken,
    confirmDeletion: confirmDeletion,
    closeConfirmation: closeConfirmation,
    openConfirmation: openConfirmation
})(DeleteAccount)));
